import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { create } from 'kts-scaffold-framework/utils/form';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import {Form, Row, Col, Select, Input, InputNumber, DatePicker, Button, Tag} from 'antd';
import moment from 'moment';

export class UIListFilterState {
    uu:number = 90;
} 

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    filterDisplay: boolean;
}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIListFilter extends UIBasic<IProps, ModulesState> {
    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    public handleSearch =(e) =>{
        e.preventDefault();
        this.props.form.validateFields((err, values) => { 
            this.modulesState.current= 1;
            this.setModulesState();

            ModulesAction.getList(values);
            ModulesAction.handleFilter(values);
            // this.modulesState.uiListFilterState.uu;
            
        }); 
    }
    public handleReset = () =>{
        this.props.form.resetFields();
        ModulesAction.resetFields();
    }
    componentDidMount () {
        if (this.modulesState.fields && this.modulesState.fields['minCreateTime']){
            this.modulesState.fields['minCreateTime'] = moment(this.modulesState.fields.minCreateTime);
        }
        if (this.modulesState.fields && this.modulesState.fields['maxCreateTime']){    
            this.modulesState.fields['maxCreateTime'] = moment(this.modulesState.fields.maxCreateTime);
        }
        ModulesAction.setModulesState();
        this.props.form.setFieldsValue(this.modulesState.fields||{});
    }
    render() {
        const FormItem = Form.Item;
        const Option = Select.Option;
        const { getFieldDecorator } = this.props.form;
        const {filterDisplay} =  this.props;
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 }
        };
        return (
            <div className={`${css.filterEntry}`} style={{display: filterDisplay ? 'block': 'none'}}>
                <Form onSubmit={this.handleSearch} >
                    <Row style={{ marginBottom: 0 }}>
                        <Col span={8}>
                            <FormItem label={`结算单号`} {...formItemLayout}>
                                {getFieldDecorator('fuzzyBizNoticeId', {
                                    rules: [
                                        {
                                            message: '不支持特殊字符',
                                            pattern: /^[A-Za-z0-9-_\u4e00-\u9fa5]+$/,
                                        }
                                    ]
                                })(
                                    <Input
                                        type="text"
                                        placeholder="支持模糊查询"
                                    />
                                )}
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <FormItem label={`销方名称`} {...formItemLayout}>
                                {getFieldDecorator('fuzzySupplierName', {
                                    rules: [
                                        {
                                            message: '不支持特殊字符',
                                            pattern: /^[\u4E00-\u9FA5A-Za-z0-9()（）]+$/,
                                        }
                                    ]
                                })(
                                    <Input
                                        type="text"
                                        placeholder="支持模糊查询"
                                    />
                                )}
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <FormItem label={`日 期`} {...formItemLayout}>
                                <Col span={11}>
                                    <FormItem>
                                        {getFieldDecorator('minCreateTime')(
                                            <DatePicker
                                                style={{ width: '100%' }}
                                            />
                                        )}
                                    </FormItem>
                                </Col>
                                <Col span={2}>
                                    <span
                                        style={{
                                            display: 'inline-block',
                                            width: '100%',
                                            textAlign: 'center'
                                        }}
                                    >
                                        -
                                    </span>
                                </Col>
                                <Col span={11}>
                                    <FormItem>
                                        {getFieldDecorator('maxCreateTime')(
                                            <DatePicker
                                                style={{ width: '100%' }}
                                            />
                                        )}
                                    </FormItem>
                                </Col>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8}>
                            <FormItem label="价税合计" {...formItemLayout}>
                                <Col span={11}>
                                    <FormItem>
                                        {getFieldDecorator('minAmountSum')(
                                            <InputNumber
                                                min={0}
                                                style={{ width: '100%' }}
                                                placeholder="请输入起始金额"
                                            />
                                        )}
                                    </FormItem>
                                </Col>
                                <Col span={2}>
                                <span className={css['span-inline-style']}>-</span>
                                </Col>
                                <Col span={11}>
                                    <FormItem>
                                        {getFieldDecorator('maxAmountSum')(
                                            <InputNumber
                                                min={0}
                                                style={{ width: '100%' }}
                                                placeholder="请输入结束金额"
                                            />
                                        )}
                                    </FormItem>
                                </Col>
                            </FormItem>
                        </Col>

                        <Col span={8}>
                            <FormItem label={`状态`} {...formItemLayout}>
                                {getFieldDecorator('noticeBillState')(
                                    <Select
                                        allowClear={true}
                                        placeholder="请选择状态"
                                    >
                                        <Option value="CREATED">已创建</Option>
                                        <Option value="SENDED">已发送</Option>
                                        <Option value="ACCEPTED">已接受</Option>
                                        <Option value="REFUSED">已拒绝</Option>
                                        <Option value="INVALID">已作废</Option>
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <FormItem label={`匹配状态`} {...formItemLayout}>
                                {getFieldDecorator('billMatchState')(
                                    <Select
                                        allowClear={true}
                                        placeholder="请选择匹配状态"
                                    >
                                        <Option value="NOTMATCH">未匹配</Option>
                                        <Option value="MATCHING">匹配中</Option>
                                        <Option value="MATCHFINISH">
                                            已匹配
                                        </Option>
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8}>
                            <FormItem label="匹配差异" {...formItemLayout}>
                                <Col span={11}>
                                    <FormItem>
                                        {getFieldDecorator('minAmountMatchedTolerance')(
                                            <InputNumber
                                                style={{ width: '100%' }}
                                                placeholder="请输入起始金额"
                                            />
                                        )}
                                    </FormItem>
                                </Col>
                                <Col span={2}>
                                    <span className={css['span-inline-style']}>-</span>
                                </Col>
                                <Col span={11}>
                                    <FormItem>
                                        {getFieldDecorator('maxAmountMatchedTolerance')(
                                            <InputNumber
                                                style={{ width: '100%' }}
                                                placeholder="请输入结束金额"
                                            />
                                        )}
                                    </FormItem>
                                </Col>
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <FormItem label="税差" {...formItemLayout}>
                                <Col span={11}>
                                    <FormItem>
                                        {getFieldDecorator('minAmountMatchedTaxTolerance')(
                                            <InputNumber
                                                style={{ width: '100%' }}
                                                placeholder="请输入起始金额"
                                            />
                                        )}
                                    </FormItem>
                                </Col>
                                <Col span={2}>
                                    <span className={css['span-inline-style']}>-</span>
                                </Col>
                                <Col span={11}>
                                    <FormItem>
                                        {getFieldDecorator('maxAmountMatchedTaxTolerance')(
                                            <InputNumber
                                                style={{ width: '100%' }}
                                                placeholder="请输入结束金额"
                                            />
                                        )}
                                    </FormItem>
                                </Col>
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <Col span={6} />
                            <Col span={18}>
                                <div className="filter-btn">
                                    <Button
                                        onClick={this.handleReset}
                                    >
                                        清空
                                    </Button>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                    >
                                        筛选
                                    </Button>
                                </div>
                            </Col>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/InputSettlement/UI.List.Filter.tsx